import { actionCopyDe } from "./actionCopy";
import { listCopyDe } from "./listCopy";

export const templatesCopyDe = {
    templates: "Vorlagen",
    navDescription: "Vorlagen durchsuchen und Patienten zur Verlaufsdokumentation einladen.",
    myTemplatesTitle: "Meine Vorlagen",
    myTemplatesDescription:
        "Erstellen und verwalten Sie Vorlagen, um Patienten schnell zur Verlaufsdokumentation einzuladen. Klicken Sie auf eine Zeile, um eine Vorlage zu verwenden, oder öffnen Sie das Menü für weitere Aktionen.",
    myTemplatesAria: "Meine Vorlagen",
    publicTemplatesTitle: "Öffentliche Vorlagen",
    breadcrumbNew: "Neu",
    selectAtLeastOneTemplate: "Wählen Sie mindestens eine Vorlage aus",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Vorlage zu meinem Konto hinzufügen" : `${count} Vorlagen zu meinem Konto hinzufügen`,
    creatingTemplates: "Vorlagen werden erstellt…",
    publicTemplatesDescription:
        "Durchsuchen Sie fertige Setups und fügen Sie sie Ihrem Konto hinzu, oder erstellen Sie Ihre eigene. Wählen Sie eine Vorlage, um schnell zu starten.",
    browsePublic: "Öffentliche ansehen",
    browsePublicAria: "Öffentliche Vorlagen ansehen",
    newTemplate: "Neue Vorlage",
    newTemplateAria: "Neue Vorlage",
    makeMyOwn: "Eigene erstellen",
    favourites: "Favoriten",
    noQuestionnaires: "Keine Fragebögen",
    moreQuestionnaires: (count) => `+${count} weitere`,
    useTemplate: "Vorlage verwenden",
    newDiary: "Neues Tagebuch",
    searchPlaceholder: "Vorlagen suchen…",
    searchAria: "Vorlagen suchen",
    clearSearchAria: actionCopyDe.clearSearch,
    filters: actionCopyDe.filters,
    clearAll: actionCopyDe.clearAll,
    procedureFilterPrefix: "Behandlung:",
    statusFilterPrefix: "Status:",
    substanceFilterPrefix: "Substanz:",
    subsiteFilterPrefix: "Teilbereich:",
    siteFilterPrefix: "Lokalisation:",
    typeFilterPrefix: "Typ:",
    areaFilterPrefix: "Bereich:",
    consultationFilterPrefix: "Beratung:",
    removeProcedureFilterAria: (label) => `Behandlungsfilter ${label} entfernen`,
    removeStatusFilterAria: (label) => `Statusfilter ${label} entfernen`,
    removeOwnerFilterAria: (name) => `Eigentümerfilter ${name} entfernen`,
    removePeopleFilterAria: (name) => `Personenfilter ${name} entfernen`,
    removeSubstanceFilterAria: "Substanzfilter entfernen",
    removeSubsiteFilterAria: "Teilbereichsfilter entfernen",
    removeSiteFilterAria: "Lokalisationsfilter entfernen",
    removeShockwaveTypeFilterAria: "Stoßwellentyp-Filter entfernen",
    removeAreaFilterAria: "Bereichsfilter entfernen",
    removeConsultationFilterAria: "Beratungsfilter entfernen",
    ownerFilterLabel: "Eigentümer (Behandler oder Sekretariat)",
    ownerFilterPlaceholder: "Alle Benutzer",
    statusFilterLabel: "Status",
    statusFilterPlaceholder: "Alle Status",
    peopleOnTemplateLabel: "Personen in der Vorlage",
    peopleOnTemplatePlaceholder: "Beliebige Person in der Vorlage",
    procedureTypeLabel: "Behandlungsart",
    procedureTypePlaceholder: "Beliebige Behandlungsart",
    areaLabel: "Bereich",
    substanceLabel: "Substanz",
    subsiteLabel: "Teilbereich",
    typeLabel: "Typ",
    siteLabel: "Lokalisation",
    consultationLabel: "Beratung",
    selectPlaceholder: "Auswählen…",
    clearFilterAria: (label) => `${label} löschen`,
    injection: "Injektion",
    shockwave: "Stoßwelle",
    surgery: "Operation",
    consultation: "Beratung",
    medication: "Medikation",
    product: "Produkt",
    published: listCopyDe.published,
    draft: listCopyDe.draft,
    noTemplatesYet: "Noch keine Vorlagen",
    noMatchingTemplates: "Keine passenden Vorlagen",
    noTemplatesYetHint: "Erstellen Sie Ihre erste Vorlage, um Patienten schnell einzuladen.",
    noMatchingHint: "Passen Sie Suche oder Filter an.",
    createFirstTemplate: "Erste Vorlage erstellen",
    emptyTemplatesHelpLink: "Wie erstelle ich eine Vorlage?",
    tableHint:
        "Klicken Sie auf eine Zeile, um einen Patienten aus dieser Vorlage einzuladen. Nutzen Sie die Symbole in jeder Zeile oder öffnen Sie das Menü für dieselben Aktionen und mehr.",
    forms: "Fragebögen",
    lastEdited: "Zuletzt bearbeitet",
    procedure: "Behandlung",
    area: "Bereich",
    people: "Personen",
    details: "Details",
    actions: listCopyDe.actions,
    select: "Auswählen",
    useTemplateAria: "Neues Tagebuch",
    editTemplateAria: "Vorlage bearbeiten",
    tapToUseTemplate: "Tippen, um diese Vorlage zu verwenden",
    useThisTemplateAria: "Diese Vorlage verwenden",
    clickRowToUseAria: "Zeile anklicken, um diese Vorlage zu verwenden",
    publicTemplatesTableAria: "Öffentliche Vorlagen",
    yourTemplatesTableAria:
        "Ihre Vorlagen; wählen Sie eine Zeile, um diese Vorlage zu verwenden, oder nutzen Sie die Aktionen in jeder Zeile",
    noTemplatesInView: "Keine Vorlagen in dieser Ansicht.",
    showingTemplatesRange: (start, end, total) => `Vorlagen ${start} bis ${end} von ${total}`,
    previous: actionCopyDe.previous,
    next: actionCopyDe.next,
    save: actionCopyDe.save,
    rename: actionCopyDe.rename,
    editTemplate: "Vorlage bearbeiten",
    addToFavourites: "Zu Favoriten hinzufügen",
    removeFromFavourites: "Aus Favoriten entfernen",
    copyUrl: "URL kopieren",
    shareTemplate: "Vorlage teilen",
    labelsAndDiaryType: "Labels und Tagebuchtyp",
    publishTemplate: "Vorlage veröffentlichen",
    duplicate: actionCopyDe.duplicate,
    delete: actionCopyDe.delete,
    deleteTemplateTitle: "Vorlage löschen",
    deleteTemplateDescription:
        "Möchten Sie diese Vorlage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel: actionCopyDe.cancel,
    templateUpdatedToast: "Vorlage erfolgreich aktualisiert",
    copiedToClipboardToast: "In die Zwischenablage kopiert",
    unnamedTemplate: "Unbenannte Vorlage",
    questionnaireSchedule: "Fragebogenplan",
    interventionStep: "Behandlung",
    injectionDetails: "Injektionsdetails",
    surgeryClinicians: "Operationsbehandler",
    surgeryDetails: "Operationsdetails",
    shockwaveClinicians: "Stoßwellenbehander",
    shockwaveDetails: "Stoßwellendetails",
    noIntervention: "Keine Behandlung",
    dateStep: "Datum",
    dateQuestion: "Ab welchem Datum werden die Nachbefragungen gezählt?",
    dateDiaryStart: "Ab dem Tag, an dem das Tagebuch erstellt wird",
    dateDiaryStartHint: "Die Fragebögen beginnen sofort. Der Patient wird nicht nach einem Datum gefragt.",
    dateAskPatient: "Leer lassen - der Patient teilt es uns mit",
    dateAskPatientHint:
        "Der Patient gibt das Datum bei der Einrichtung seines Tagebuchs an. Sie können es auch später ergänzen.",
    saveTemplate: "Vorlage speichern",
    lockLabel: "Sperren",
    unlockLabel: "Entsperren",
    lockedLabel: "Gesperrt",
    lockedByTemplateCreator: "Vom Vorlagenersteller gesperrt",
    usageInstructionsPlaceholder: "z. B. Täglich 2 Stunden tragen, nach Gebrauch reinigen",
    productNameRequired: "Produktname ist erforderlich",
    contactEmail: "Kontakt-E-Mail",
    contactPersonDescription:
        "Ansprechpartner für Patienten, die weiteren Kontakt mit der Klinik wünschen. Diese E-Mail-Adresse wird mit dem Patienten geteilt.",
    selectContactPlaceholder: "Kontakt-E-Mail auswählen",
    defaultContactForOrganisation: (organisationNames) => `Standard für ${organisationNames}`,
    templateCreatedTitle: "Vorlage erfolgreich erstellt!",
    templateCreatedMessage: "Gesparte Zeit ist gewonnene Zeit!",
    templateNotFoundTitle: "Vorlage nicht gefunden",
    templateNotFoundDescription: "Die Vorlage konnte nicht gefunden werden. Bitte versuchen Sie es erneut.",
    backToTemplates: "Zurück zu den Vorlagen",
    userFallback: (idPrefix) => `Benutzer ${idPrefix}…`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Injektion",
            shockwave: "Stoßwelle",
            surgery: "Operation",
            education: "Beratung",
            medication: "Medikation",
            product: "Produkt",
        };
        return map[type] ?? type;
    },
    statusLabel: (status) => (status === "published" ? "Veröffentlicht" : "Entwurf"),
};
